import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { ClientLpAction } from '../clientLp.action';

export const startClientLpProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    ClientLpAction.update.started,
  ),
  mergeMap(() => {
    return [
      ClientLpAction.processing.started(),
    ];
  }),
);
